import { baseUrl } from '../../baseurl';
import { create } from 'zustand';
import axios from 'axios';

export const useLocations = create((set, get) => ({
  countries: [],
  provinses: [],
  cities: [],
  areas: [],
  neighbourhood: [-1],
  showServerError: false,
  aDistrictName: "",
  districtNames: [],

  actions: {
    getAllCountries: () => {
      axios.get(`${baseUrl}/CityState/GetLocationByMasterId?masterId=1`)
        .then(res => {
          set({ countries: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllProvinses: (id) => {
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${!id ? 1 : id}`)
        .then(res => {
          set({ provinses: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllAreas: (id) => {
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${id}`)
        .then(res => {
          set({ areas: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllCities: (id) => {
      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${!id ? 3 : id}`)
        .then(res => {
          set({ cities: res.data });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllNeighbourhood: (id) => {

      axios.get(`${baseUrl}/CityState/GetLocationByParentId?parentId=${!id ? 3 : id}`)
        .then(res => {
          set({ neighbourhood: res.data });
          console.log('res.data');
          console.log(res.data[0]);
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllDistricts: (id) => {
      console.log(id, "idddddddddddddddddd");

      axios.get(`${baseUrl}/CityState/GetLocationById?Id=${id}`)
        .then(res => {
          console.log(res, "ressssssssssssssssssss");

          set({ aDistrictName: res?.data?.locName });

        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
    getAllDistrictswithArray: (ids) => {
      console.log(ids, "idddddddddddddddddd222222222222");

      axios.post(`${baseUrl}/CityState/GetLocationByIds`, {

        "ids": ids

      })
        .then(res => { 
          const u = res?.data?.map((u) => u.locName)
          console.log(u, "ressssssssssssssssssssuuu");
          set({ districtNames: u });
        })
        .catch(error => {
          set((state) => ({ showServerError: true }))
        });
    },
  },
}));

// In your component

